/**
 * Utisha Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthTokens { 
    /**
     * The Cognito access token
     */
    accessToken: string;
    /**
     * The Cognito ID token
     */
    idToken: string;
    /**
     * The Cognito refresh token, may be empty
     */
    refreshToken?: string | null;
    /**
     * The user\'s email address
     */
    username: string;
}

